import AdminApi from "@/api/admin.api";
import Vue from "vue";

const errorHandler = error => {
    Vue.prototype.$eventHub.$emit("users.error", error);
};

const state = {
    list: [],
    filters: {},
    sortBy: null,
    sortDesc: null,
    meta: null,
    loading: false,
    notVerified: 0,
    notVerifiedAccepted: 0,
};

const mutations = {
    setOrder: (state, order) => {
        state.sortBy = order.sortBy;
        state.sortDesc = order.sortDesc;
    },
    setLoading(state, status = true) {
        state.loading = status;
    },
    setFilters(state, filters) {
        state.filters = { ...filters };
    },
    setUsers(state, data) {
        state.list = [...data];
    },
    setMeta(state, meta) {
        state.meta = { ...meta };
    },
    setNotVerified: (state, notVerified) => (state.notVerified = notVerified),
    setNotVerifiedAccepted: (state, notVerifiedAccepted) => (state.notVerifiedAccepted = notVerifiedAccepted),
};

function prepareFilters(state, page) {
    const filters = Object.keys(state.filters).reduce((acc, key) => {
        const value = state.filters[key];
        if (value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    if (page > 1) {
        filters.page = page;
    }

    filters.role = 'organizer';

    if (state.orderBy) {
        filters.orderBy = state.sortBy;
        filters.sortOrder = state.sortDesc ? 'desc' : 'asc';
    }
    return filters;
}

const actions = {
    async fetchUsers({ commit, dispatch, state }, page = 1) {
        commit("setLoading");
        const filters = prepareFilters(state, page);
        const { data: users, meta } = await AdminApi.Users.getList(filters).catch(errorHandler);
        commit("setUsers", users);
        commit("setMeta", meta);
        commit("setLoading", false);

        dispatch("fetchCheckVerify");
    },

    fetchCheckVerify({ commit }) {
        const url = `/admin/profiles/checkVerify?role=organizer`;
        return axios.get(url).then(res => {
            commit("setNotVerified", res.data.notVerified);
            commit("setNotVerifiedAccepted", res.data.notVerifiedAccepted);
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
